document.addEventListener('DOMContentLoaded', () => {
  const maxLength = 200;

  document.querySelectorAll('.review-text-wrapper').forEach(wrapper => {
    const fullEl = wrapper.querySelector('.review-text.full');
    const truncEl = wrapper.querySelector('.review-text.truncated');
    const showBtn = wrapper.querySelector('.show-more-btn');
    const lessBtn = wrapper.querySelector('.show-less-btn');

    const text = fullEl.textContent.trim();
    fullEl.textContent = text;

    if (text.length > maxLength) {
      truncEl.textContent = text.slice(0, maxLength) + '…';
      showBtn.classList.remove('hide');
    } else {
      truncEl.textContent = text;
    }

    showBtn.addEventListener('click', () => {
      truncEl.classList.add('hide');
      fullEl.classList.remove('hide');
      showBtn.classList.add('hide');
      lessBtn.classList.remove('hide');
    });

    lessBtn.addEventListener('click', () => {
      truncEl.classList.remove('hide');
      fullEl.classList.add('hide');
      showBtn.classList.remove('hide');
      lessBtn.classList.add('hide');
    });
  });
});
